<div class="header">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 col-sm-6 col-6">
        <!-- <div class="logo">
          <img src="../../../assets/images/refresh-logo.svg" alt="" *ngIf="selectedBusiness == 'REFRESH'" (click)="routeTodashboard()">
          <img src="../../../assets/images/zones-logo.svg" alt="" *ngIf="selectedBusiness == 'ZONES'" (click)="routeTodashboard()">
        </div> -->
        <div class="logo">
          <img
            src="../../../assets/images/refresh-control-logo1.svg"
            alt=""
            *ngIf="selectedBusiness == 'REFRESH'"
            (click)="routeTodashboard()"
          />
          <img
            src="../../../assets/images/refresh-zones-logo1.svg"
            alt=""
            *ngIf="selectedBusiness == 'ZONES'"
            (click)="routeTodashboard()"
          />
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-6">
        <div class="header-right d-flex align-items-center justify-content-end">

          <span class="hr-text"> Contractor Portal </span>
          |
         
          <span class="hr-text" style="margin-left: 5px;"> {{ subcontractorName }} </span>
          |
          <span class="user-icon" [matMenuTriggerFor]="menu">
            <!-- <mat-icon>person</mat-icon> -->
            <img src="../../../assets/images/user-icon.jpg" alt="" class="" />
          </span>
          <mat-menu #menu="matMenu" class="user-menu">
            <button mat-menu-item (click)="routeToChangePass()">
              <mat-icon>lock</mat-icon>
              <span>Change Password</span>
            </button>
            <button mat-menu-item (click)="routeToProfile()">
              <mat-icon>person</mat-icon>
              <span>My Profile</span>
            </button>
            <button mat-menu-item (click)="logout()">
              <mat-icon>power_settings_new</mat-icon>
              <span>Log Out</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
</div>
